"use client";
import SHOPPING_CART_ICON from "@assets/svg/shopping_cart_blue_icon.svg";
import { addToCart } from "@lib/data/cart";
import useToggleState from "@lib/hooks/use-toggle-state";
import Spinner from "@modules/common/icons/spinner";
import CartDrawer from "@modules/layout/components/cart-drawer";
import Image from "next/image";
import { useParams } from "next/navigation";
import { useRef, useState } from "react";
import { ExtendedStoreCart, ExtendedStoreProduct } from "types/global";
import PreviewPrice from "./price";

type Props = {
  product: ExtendedStoreProduct;
  cheapestPrice: any;
  cart: ExtendedStoreCart | null;
};

function Action({ product, cheapestPrice, cart }: Props) {
  const countryCode = useParams().countryCode as string;
  const [isAdding, setIsAdding] = useState(false);
  const isOutOfStock =
    product.variants?.[0]?.inventory_items?.[0]?.inventory?.location_levels?.[0]?.stocked_quantity === 0;

  const { state, close, toggle } = useToggleState();

  const totalItems = cart?.items?.reduce((acc, item) => acc + item.quantity, 0) || 0;

  const prevTotalItems = useRef<number>(totalItems);

  const handleToggle = () => {
    setTimeout(() => toggle(), 1000);
  };

  async function handleAddToCart() {
    if (!product || !product.variants?.length) {
      console.error("Sản phẩm không hợp lệ hoặc không có biến thể!");
      return;
    }

    const variant = product.variants[0];
    if (!variant.id) {
      console.error("Không tìm thấy ID của biến thể!");
      return;
    }

    setIsAdding(true);

    try {
      await addToCart({
        variantId: variant.id,
        quantity: 1,
        countryCode,
      });
      prevTotalItems.current = totalItems + 1;
      if (totalItems != prevTotalItems.current) handleToggle();
    } catch (error) {
      console.error("Lỗi khi thêm vào giỏ hàng:", error);
    } finally {
      setIsAdding(false);
    }
  }

  return (
    <div className="flex justify-between w-full items-center">
      <div className="flex flex-col">{cheapestPrice && <PreviewPrice price={cheapestPrice} />}</div>
      {isAdding ? (
        <Spinner className="animate-spin" />
      ) : (
        !isOutOfStock &&
        cheapestPrice && (
          <div className="cursor-pointer group relative" onClick={() => handleAddToCart()}>
            <span className="absolute z-10 left-1/2 bottom-full mb-1 -translate-x-1/2 bg-gray-800 text-gray-300 text-xs px-2 py-1 rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              Shop Now
            </span>
            <Image src={SHOPPING_CART_ICON} alt="SHOPPING_CART_ICON" />
          </div>
        )
      )}
      <CartDrawer cart={cart} isOpen={state} onClose={close} />
    </div>
  );
}

export default Action;
